import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SkuLookup'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SkuLookupStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SkuLookupStore",
			variables: true,
		})
	}
}

export async function load_SkuLookup(params) {
  await initClient()

	const store = new SkuLookupStore()

	await store.fetch(params)

	return {
		SkuLookup: store,
	}
}
